import React, { useEffect, useState } from 'react';
import { useGetAccount, useGetNetworkConfig, useGetPendingTransactions } from '@multiversx/sdk-dapp/hooks';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { isMobile } from 'react-device-detect';
import { FarmPool } from 'components/FarmPool';
import egld_white_logo from 'assets/img/EGLD_white.svg';
import { queryViewJewelFarmBaseContext, queryViewJewelLendContext } from 'z/elrond';
import { JewelFarmBaseContext, JewelFarmContext, JewelLendPool } from 'z/types';
import { Spinner } from 'components/Spinner';

export const Farm = () => {

    const {
        network: { apiAddress },
    } = useGetNetworkConfig();
    const { address, balance } = useGetAccount();
    const { hasPendingTransactions } = useGetPendingTransactions();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [commonSettings, setCommonSettings] = useState<JewelFarmBaseContext | undefined>();
    const [lendPools, setLendPools] = useState<JewelLendPool[]>([]);
    useEffect(() => {
        if (hasPendingTransactions) return;

        (async () => {
            setIsLoading(true);
            const _commonSettings = await queryViewJewelFarmBaseContext(apiAddress, address, balance);
            console.log('_commonSettings', _commonSettings);
            if (_commonSettings) {
                setCommonSettings(_commonSettings);
            }

            const _lendCommonSettings = await queryViewJewelLendContext(apiAddress, address, balance);
            console.log('_lendCommonSettings', _lendCommonSettings);
            if (_lendCommonSettings) {
                setLendPools(_lendCommonSettings.lendPool);
            }
            setIsLoading(false);
        })();
    }, [hasPendingTransactions, address]);

    return (
        <div className='container' style={{ marginTop: '40px' }}>
            <div className='info-item'>
                <div className='d-flex justify-content-between align-items-center'>
                    <div className='title'>
                        <span>Farms</span>
                    </div>
                    <div className='egld-logo' >
                        <img src={egld_white_logo} />
                    </div>
                </div>
                {!isMobile && (
                    <div className='row mt-4' style={{ justifyContent: "center" }}>
                        <div className='col-lg-4 col-md-4 col-sm-4 text-center'>
                            <div>Pool</div>
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-3 text-center'>
                            <div>TVL</div>
                        </div>
                        <div className='col-lg-1 col-md-1 col-sm-1 d-flex justify-content-center'>
                            <div className='d-flex'>
                                <div>APY</div>
                                <Tooltip
                                    placement="top"
                                    title="Based on APY of the current underlying farming pools. It does not include fees from occasional rebalancing"
                                >
                                    <InfoCircleOutlined className='h6 mx-1' style={{ marginTop: '1px', cursor: 'pointer' }} />
                                </Tooltip>
                            </div>
                        </div>
                        <div className='col-lg-2 col-md-2 col-sm-2 text-center'>
                            <div>Leverage</div>
                        </div>
                        <div className='col-lg-2 col-md-2 col-sm-2'></div>
                    </div>
                )}
                {isLoading ? (
                    <div className='mt-5'>
                        <Spinner />
                    </div>
                ) : (
                    <div className='row mt-1' style={{ justifyContent: "center" }}>
                        {commonSettings && lendPools.length > 0 && (
                            <div className='col-12'>
                                {commonSettings.farms.map((farmPool: JewelFarmContext, index: number) => (<FarmPool key={index} commonSettings={commonSettings} farmPool={farmPool} lendPools={lendPools} />))}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
